import { useTranslation } from 'react-i18next';

import type { Role } from '../types/role.types';
import { RoleListRow } from './RoleListRow';

interface RoleListTableProps {
  roles: readonly Role[];
}

export function RoleListTable({ roles }: RoleListTableProps) {
  const { t } = useTranslation('roles');
  // PRD §3.1: default sort UID ascending, Seeds first. Sort defensively.
  const sorted = [...roles].sort((a, b) => a.id - b.id);

  return (
    <div className="card">
      <table className="table" style={{ margin: 0 }}>
        <thead>
          <tr style={{ background: 'var(--muted)' }}>
            <th style={{ width: 60 }}>{t('list.columns.uid')}</th>
            <th style={{ width: 220 }}>{t('list.columns.actions')}</th>
            <th>{t('list.columns.name')}</th>
            <th style={{ width: 180 }}>{t('list.columns.updatedAt')}</th>
            <th style={{ width: 180 }}>{t('list.columns.createdAt')}</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((role) => (
            <RoleListRow key={role.id} role={role} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
